module.exports = __webpack_public_path__ + "img/programme_funeng_pic_commodity@3x.9fdae365.png";